import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { convertThenFormat, formatDateTimezon } from "../common-data/Converts";
import UPTMListingsMobile from "./UPTMListingsMobile";

const UPTMListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  const {
    upgradePtMemberships,
    upgradePtMembershipsLoading,
    upgradePtMembershipsError,
  } = useSelector((state) => state.plans);

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  useEffect(() => {
    if (
      upgradePtMemberships?.status &&
      upgradePtMemberships?.data?.length > 0 &&
      !upgradePtMembershipsLoading &&
      !upgradePtMembershipsError
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: upgradePtMemberships.data,
        pagination:
          upgradePtMemberships?.pagination?.length > 0
            ? upgradePtMemberships.pagination
            : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [
    upgradePtMemberships,
    upgradePtMembershipsLoading,
    upgradePtMembershipsError,
  ]);

  const tbColumns = [
    {
      dataField: "user_id",
      text: "member detail",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.user_name || "NA"}
            <br />
            <small className="lowercase underline">
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "upgraded_by",
      text: "added by",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.upgraded_by_name || "NA"} <br />
            <small className="lowercase underline">
              {row?.upgraded_by_mobile || ""}
              <br />
              {row?.upgraded_by_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "is_partial",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "current_subscription_status",
      text: "plan status",
      formatter: (_, row) => {
        const planStatus = row?.current_subscription_status
          ?.replace(/ /g, "_")
          ?.toLowerCase();

        return (
          <>
            <span
              className="tb-data minWidth150 withPadding borderRdius27"
              style={{
                background:
                  planStatus === "active"
                    ? "#379C00"
                    : planStatus === "expiring"
                    ? "#EB8317"
                    : "#D90000",
                color: "#fff",
              }}>
              {row?.current_subscription_status || "NA"}
            </span>

            <br />

            {row?.current_plan_name && (
              <span className="tb-data underline">
                <small>{row.current_plan_name || ""}</small>
              </span>
            )}

            <br />

            {row?.subscription_expiry_days && (
              <span className="tb-data">
                <small>({row.subscription_expiry_days || ""})</small>
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "n_session",
      text: "Sessions",
      formatter: (_, row) => (
        <span className="tb-data">
          {row?.n_session || 0}
          {row?.session_duration ? (
            <>
              <br />
              <small className="gray">({row.session_duration} days)</small>
            </>
          ) : null}
        </span>
      ),
    },
    {
      dataField: "date_added",
      text: "Start/Expire Date",
      formatter: (_, row) => (
        <span className="tb-data minWidth100 underline">
          <small className="gray underline">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </small>
          <br />
          {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
          <br />
          {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
        </span>
      ),
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (_, row) => (
        <span
          className={`tb-data ${row?.is_partial ? "link" : ""}`}
          onClick={() =>
            row?.is_partial
              ? setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "partial_details",
                  partialDetails: row?.payment_details || [],
                }))
              : null
          }>
          {row?.is_partial ? "Partial" : "Full"}
        </span>
      ),
    },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (_, row) => (
        <span className="tb-data">₹{convertThenFormat(row?.price || 0)}</span>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (_, row) => (
        <span className="tb-data">
          {row?.is_partial
            ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
            : "-"}
        </span>
      ),
    },
    {
      dataField: "total_online",
      text: "Online/Cash Amount",
      formatter: (_, row) => (
        <span className="tb-data minWidth150">
          <small>
            ₹
            {convertThenFormat(
              row?.is_partial
                ? row?.partial_total_online
                : row?.total_online || 0
            )}
            / ₹
            {convertThenFormat(
              row?.is_partial ? row?.partial_total_cash : row?.total_cash || 0
            )}
          </small>
        </span>
      ),
    },
  ];

  return (
    <>
      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table hideMobile mt30">
        {upgradePtMembershipsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            isFirstColSticky={true}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>

      <div className="lead-logs-card-container only-mobile">
        <UPTMListingsMobile
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          setModValues={setModValues}
        />
      </div>
    </>
  );
};

export default UPTMListings;
